// extracted by mini-css-extract-plugin
export default {"edroloLogo":"EdroloLogo__edroloLogo___ks0B4"};